/* eslint-disable @typescript-eslint/no-explicit-any */

import { ApiError } from "api/shared";
import { AxiosError } from "axios";

/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
export const GENERIC_ERROR = "Unknown error";

export default function getTryCatchErrorMessage(e?: any): string {
  const error = e as AxiosError<ApiError>;
  if (error?.response?.data?.error) {
    return error?.response?.data?.error;
  }

  if (error?.message) {
    return e.message;
  }

  if (typeof e === "string") {
    return e;
  }
  return GENERIC_ERROR;
}
